import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  connect() {
    this.offcanvas = bootstrap.Offcanvas.getOrCreateInstance(this.element)
  }

  open() {
    $(this.element).removeClass('d-none')
    this.offcanvas.show()
  }

  close() {
    $(this.element).addClass('d-none')
    this.offcanvas.hide()
  }
}